module.exports = __webpack_public_path__ + "static/media/ABOUT_DARKMODE.f4467f71.webp";